<template>
    <div style="width:100%;height:100%">
    <svg id="svg" style="border:1px solid red;background:#2D3039" class="svg unselectable" @drop="handleDrop" @dragover="allowDrop">
    </svg>
        <button @click="getData">获取数据</button>
    </div>
</template>
<script>

require(`snapsvg`);
import tflow from "@/assets/tflow/index"
import booldRender from "./groupRender/bloodRender"
import "./groupRender/bloodRender.css"
import md5 from "md5"
const uuidv1 = require('uuid/v1');

export default {
    name: "DataFlowIndex",
    data() {
        return {
           flow:null,
        }
    },
    mounted() {
        
        tflow.groupRenderRegister("blood",booldRender)
        let config  = {
            groupRender:"table",
            onlinkconnecting:function(el){
                let c = el.select(".tflow-connection").attr({stroke:"#258FFF"})
                el.select(".tflow-connection-edge").attr({stroke:"#222237"})
                el.select(".arrow").attr({stroke:"#258FFF"})
                let {x,y} = Snap.path.getPointAtLength(c.attr().d, 0)
                let circle = el.select("circle")
                if(circle){
                    circle.attr({
                        cx:x,cy:y,r:4
                    })
                }
            },
            onlinkconnected:function(el){
                let c = el.select(".tflow-connection").attr({stroke:"#258FFF"})
                let {x,y} = Snap.path.getPointAtLength(c.attr().d, 0)
                el.circle(x, y, 4).attr({
                    fill: "#258FFF",
                })
                el.select(".tflow-connection-edge").attr({stroke:"#222237"})
                el.select(".arrow").attr({stroke:"#258FFF"})

                
            }
        }
        this.flow  = tflow.init("#svg",[],[],config)
        
        // svg.rect()
        // drawTable(this.svg,{position:[100,100]})
    },
    methods: {
        // 外部元素掉落
        handleDrop(e) {
            let tableObj = JSON.parse(e.dataTransfer.getData("Text"));

            let position = [e.offsetX, e.offsetY]


            //生成table的图像数据

            const { connName, databaseName, tableName } = tableObj;
            let tableid = md5(`${connName}${databaseName}${tableName}`);
            let group = {
                id: uuidv1(),
                tableid,
                connName,
                databaseName,
                name: tableName,
                position,
                nodes:[ ...tableObj.tableColumnInfo.map(v => ({
                    id: uuidv1(),
                    name: v.COLUMN_NAME,
                    category:"field",
                    ports: [
                        {
                            direction:"left"
                        },
                        {
                            direction:"right"
                        }
                    ]
                })),
                {
                    id:uuidv1(),
                    name:tableName,
                    category:"table",
                    ports: [
                        {
                            direction:"left"
                        },
                        {
                            direction:"right"
                        }
                    ]
                }
                ],
            }
            this.flow.addGroup(group)
            
            // this.groups.push(group)
            // drawTable(this.svg, group, this.handleDragOnMove, this.handleDragOnStart, this.handleOnEnd)

        },
        allowDrop(e) {
            e.preventDefault();
        },
        getData(){
            let groupsData = this.flow.getGroupsData()
            let linksData = this.flow.getLinksData();
            console.log(JSON.stringify(groupsData),JSON.stringify(linksData))

        }
        
    }
}
</script>
<style scoped>
.svg {
  box-sizing: border-box;
  min-width: 100%;
  min-height: 100%;
}
</style>
<style>

</style>


// WEBPACK FOOTER //
// src/components/DataFlow/index.vue